import { generateUniqueId } from '../../helpers/common';

export const SET_MESSAGE = generateUniqueId();
export const TOGGLE_REPORT_DIALOG = generateUniqueId();
export const FILTER_STATUS = generateUniqueId();

export const SUBMIT_REPORT_REQUEST = generateUniqueId();
export const SUBMIT_REPORT_SUCCESS = generateUniqueId();
export const SUBMIT_REPORT_FAILURE = generateUniqueId();

export const CLOSE_ERROR_REPORT_REQUEST = generateUniqueId();
export const CLOSE_ERROR_REPORT_SUCCESS = generateUniqueId();
export const CLOSE_ERROR_REPORT_FAILURE = generateUniqueId();

export const REOPEN_ERROR_REPORT_REQUEST = generateUniqueId();
export const REOPEN_ERROR_REPORT_SUCCESS = generateUniqueId();
export const REOPEN_ERROR_REPORT_FAILURE = generateUniqueId();

export const SEARCH_REQUEST = generateUniqueId();
export const SEARCH_SUCCESS = generateUniqueId();
export const SEARCH_FAILURE = generateUniqueId();

export const CHANGE_PAGINATION_PAGE = generateUniqueId();
export const CHANGE_PAGINATION_ROWS_PER_PAGE = generateUniqueId();
export const SET_KEYWORD = generateUniqueId();
export const SET_BUFFERED_KEYWORD = generateUniqueId();

export const CLOSE_SNACK_BAR = generateUniqueId();
export const REOPEN_SNACK_BAR = generateUniqueId();

export const SELECT_ERROR_REPORT = generateUniqueId();

export const TOGGLE_DETAIL_DIALOG = generateUniqueId();